import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from '@/app/router'
import { useAuthInit } from '@/shared/hooks/use-auth'
import { WebSocketProvider } from '@/app/providers/websocket-provider'
import { ToastProvider } from '@/shared/components/ui/toast'
import { ErrorBoundary } from '@/shared/components/error-boundary'
import { PageViewTracker } from '@/shared/analytics'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Runs silent refresh + /auth/me on mount. AppShell keeps header/sidebar visible
// during bootstrap and gates <Outlet /> until isBootstrapped so feature routes
// do not fire API calls without an access token.
function AuthInitializer({ children }: { children: React.ReactNode }) {
  useAuthInit()
  return <>{children}</>
}

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthInitializer>
            <ToastProvider>
              <WebSocketProvider>
                <PageViewTracker />
                <AppRouter />
              </WebSocketProvider>
            </ToastProvider>
          </AuthInitializer>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
